import CreateGuestGroup from '../ProtectPages/AdminPanel/GuestPanel/CreateGuestGroup';
import GuestRequestList from '../ProtectPages/AdminPanel/GuestPanel/GuestRequestList';
import MyRequests from '../ProtectPages/AdminPanel/GuestPanel/MyRequests';
import Stepper from '../ProtectPages/AdminPanel/GuestPanel/Stepper';
import ChangePassword from '../ProtectPages/UserPanel/ChangePassword'


const PrivateRoutList = [
    {
        name: 'ChangePassword',
        path: 'User/changePassword',
        element: <ChangePassword />
    },
       {
        name: 'GuestGroup:CustomCreate',
        path: 'CreateGuestGroup',
        element: <CreateGuestGroup />
    } ,

     {
        name: 'GuestRequest:Add',
        path: 'GuestRequest/Add',
        element: <Stepper />
    } ,
   {
        name: 'Requests',
        path: 'Requests',
        element: <MyRequests />
    } ,
     {
        name: 'GuestRequestList',
        path: 'GuestRequestList',
        element: <GuestRequestList />
    } ,
];
export default PrivateRoutList;

